const languages = [
  {
    "id": 1,
    "name": "English",
    "direction": "ltr",
    "cultureName": "en",
    "displayName": "en",
    "didomiCode": "en",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 31,
    "name": "Português (Brasil)",
    "direction": "ltr",
    "cultureName": "pt-br",
    "displayName": "pt-br",
    "didomiCode": "pt",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 29,
    "name": "Español (Latinoamérica)",
    "direction": "ltr",
    "cultureName": "es-419",
    "displayName": "es-mx",
    "didomiCode": "es",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 27,
    "name": "العربية",
    "direction": "rtl",
    "cultureName": "ar",
    "displayName": "ar",
    "didomiCode": "ar",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 9,
    "name": "English (US)",
    "direction": "ltr",
    "cultureName": "en-us",
    "displayName": "en-us",
    "didomiCode": "en",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 10,
    "name": "English (UK)",
    "direction": "ltr",
    "cultureName": "en-gb",
    "displayName": "en-uk",
    "didomiCode": "en",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 30,
    "name": "Português",
    "direction": "ltr",
    "cultureName": "pt-pt",
    "displayName": "pt",
    "didomiCode": "pt",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 14,
    "name": "Español (España)",
    "direction": "ltr",
    "cultureName": "es-es",
    "displayName": "es",
    "didomiCode": "es",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 16,
    "name": "Deutsch",
    "direction": "ltr",
    "cultureName": "de-de",
    "displayName": "de",
    "didomiCode": "de",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 15,
    "name": "Français",
    "direction": "ltr",
    "cultureName": "fr-fr",
    "displayName": "fr",
    "didomiCode": "fr",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 37,
    "name": "Nederlands",
    "direction": "ltr",
    "cultureName": "nl-nl",
    "displayName": "nl",
    "didomiCode": "nl",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 12,
    "name": "Italiano",
    "direction": "ltr",
    "cultureName": "it-it",
    "displayName": "it",
    "didomiCode": "it",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 33,
    "name": "Türkçe",
    "direction": "ltr",
    "cultureName": "tr-tr",
    "displayName": "tr",
    "didomiCode": "tr",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 21,
    "name": "Pусский",
    "direction": "ltr",
    "cultureName": "ru-ru",
    "displayName": "ru",
    "didomiCode": "ru",
    "isMain": true,
    "invalidUserCountryIds": []
  },
  {
    "id": 193,
    "name": "Deutsch (Österreich)",
    "direction": "ltr",
    "cultureName": "de-at",
    "displayName": "de-at",
    "didomiCode": "de",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 197,
    "name": "Nederlands (België)",
    "direction": "ltr",
    "cultureName": "nl-be",
    "displayName": "nl-be",
    "didomiCode": "nl",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 219,
    "name": "မြန်မာ",
    "direction": "ltr",
    "cultureName": "my-mm",
    "displayName": "mm",
    "didomiCode": "en",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 2,
    "name": "עברית",
    "direction": "rtl",
    "cultureName": "he-il",
    "displayName": "he",
    "isMain": true,
    "invalidUserCountryIds": [122, 131, 124, 126, 116,  117, 170, 115, 114, 119, 125, 123, 226, 130, 261, 284, 189, 161, 127, 173, 135, 139, 191, 206]
  },
  {
    "id": 34,
    "name": "Bahasa Indonesia",
    "direction": "ltr",
    "cultureName": "id-id",
    "displayName": "id",
    "didomiCode": "en",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 35,
    "name": "Polski",
    "direction": "ltr",
    "cultureName": "pl-pl",
    "displayName": "pl",
    "didomiCode": "pl",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 42,
    "name": "Dansk",
    "direction": "ltr",
    "cultureName": "da-dk",
    "displayName": "da",
    "didomiCode": "da",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 57,
    "name": "日本語",
    "direction": "ltr",
    "cultureName": "ja-jp",
    "displayName": "jp",
    "didomiCode": "ja",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 88,
    "name": "ไทย",
    "direction": "ltr",
    "cultureName": "th-th",
    "displayName": "th",
    "didomiCode": "th",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  { "id": 141,
    "name": "中文(简体)",
    "direction": "ltr",
    "cultureName": "zh-hans",
    "displayName": "zh",
    "didomiCode": "zh-CN",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 194,
    "name": "suomi",
    "direction": "ltr",
    "cultureName": "fi-fi",
    "displayName": "fi",
    "didomiCode": "fi",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 195,
    "name": "norsk",
    "direction": "ltr",
    "cultureName": "no",
    "displayName": "no",
    "didomiCode": "en",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 196,
    "name": "Bahasa Melayu",
    "direction": "ltr",
    "cultureName": "bs-my",
    "displayName": "ms",
    "didomiCode": "ms",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 198,
    "name": "svenska",
    "direction": "ltr",
    "cultureName": "sv-se",
    "displayName": "sv",
    "didomiCode": "sv",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 199,
    "name": "中文(台灣)",
    "direction": "ltr",
    "cultureName": "zh-tw",
    "displayName": "zh-tw",
    "didomiCode": "zh-TW",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 209,
    "name": "Filipino",
    "direction": "ltr",
    "cultureName": "fil-ph",
    "displayName": "fil-ph",
    "didomiCode": "en",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 216,
    "name": "हिंदी",
    "direction": "ltr",
    "cultureName": "hi-in",
    "displayName": "hi",
    "didomiCode": "en",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 210,
    "name": "Tiếng Việt",
    "direction": "ltr",
    "cultureName": "vi-vn",
    "displayName": "vi",
    "didomiCode": "vi",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {  "id": 217,
    "name": "ລາວ",
    "direction": "ltr",
    "cultureName": "lo-la",
    "displayName": "lo",
    "didomiCode": "en",
    "isMain": false,
    "invalidUserCountryIds": []
  },
  {
    "id": 158,
    "name": "فارسى",
    "direction": "rtl",
    "cultureName": "fa-ir",
    "displayName": "fa",
    "didomiCode": "en",
    "isMain": false,
    "invalidUserCountryIds": []
  }
];

module.exports = languages;
